<template lang="pug">
  .col-24.flexD.alignItemsCenter.justifyCenter.l-padding-top-3em.l-padding-bottom-3em
    .col-12.flexD.flexDirectionColumn.minWidth700.m-minWidthAuto.m-width-90
      p.fontBold.font-title.l-margin-bottom-1em {{ title }}
      .col-24.flexD.justifySpaceAround.alignItemsCenter.m-flexWrap
        img.col-4.block.m-width-20.m-margin-bottom-2em.m-margin-left-5p.m-margin-right-5p(v-for="(item, index) in imgs" :key="index" :src="item.logo")


</template>

<script>
  export default {
    name: 'wellveLogo',
    props: ['content'],
    data(){
      return{
        title: this.$t('wellve.title_3'),
        imgs: [
          { logo: require('@/assets/img/logo/logo_spotify.png')},
          { logo: require('@/assets/img/logo/logo_apple.png')},
          { logo: require('@/assets/img/logo/logo_amazon.png')},
          { logo: require('@/assets/img/logo/logo_deezer.png')},
          { logo: require('@/assets/img/logo/logo_tidal.png')},
        ]
      }
    },
    computed: {},
    methods:{},
    created(){}
  }
</script>
